import React from 'react';
import { connect } from 'react-redux';
import { Route, Redirect, matchPath } from 'react-router-dom';
import { ROUTES } from './dashboard/routes';

const isKnownDashboardRoute = pathname =>
	pathname !== '/' && ROUTES.some(r => r.path !== '/' && matchPath(pathname, { path: r.path, exact: r.exact }));

const PrivateRoute = ({ component: Component, auth, ...rest }) =>
	<Route {...rest} render={props => {
		if (auth.isAuthenticated) {
			return <Component {...props} />;
		}
		const target = isKnownDashboardRoute(props.location.pathname)
			? { pathname: '/login', search: props.location.search, state: { from: props.location } }
			: { pathname: '/public/centers', search: props.location.search, state: { from: props.location } };
		return <Redirect to={target} />;
	}}
	/>;

const mapStateToProps = (state, ownProps) => ({
	auth: state.auth
});

export default connect(mapStateToProps)(PrivateRoute);